var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSegurosOkLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255) none repeat scroll 0% 0%",
      display: "block",
      shapeRendering: "auto"
    },
    width: "211px",
    height: "211px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 17.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 17.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0.11682242990654206s",
    calcMode: "discrete"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 17.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0.2336448598130841s",
    calcMode: "discrete"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 39.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0.8177570093457943s",
    calcMode: "discrete"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 39.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0.35046728971962615s",
    calcMode: "discrete"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 61.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0.7009345794392523s",
    calcMode: "discrete"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 61.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0.5841121495327103s",
    calcMode: "discrete"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 61.5,
    width: 21,
    height: 21,
    fill: "#0db2a7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#303841;#0db2a7;#0db2a7",
    keyTimes: "0;0.125;1",
    dur: "0.9345794392523364s",
    repeatCount: "indefinite",
    begin: "0.4672897196261682s",
    calcMode: "discrete"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegurosOkLoading);
export default __webpack_public_path__ + "static/media/seguros_ok_loading.1bd1c8ff71ed86169f86c5f49caa6bf0.svg";
export { ForwardRef as ReactComponent };